import * as angular from 'angular';
import {IQService} from 'angular';
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {PdfFormTemplatesRequestsService} from "./pdf-form-templates-requests.service";
import {PdfFormTemplatesAlerts} from "./pdf-form-templates-alerts.service";
import {PdfFormTemplateModel} from "../models/pdf-form-template.model";

export class PdfFormTemplatesService {

  /* @ngInject */
  constructor(private pdfFormTemplatesRequestsService: PdfFormTemplatesRequestsService,
              private $q: IQService,
              private pdfFormTemplatesAlerts: PdfFormTemplatesAlerts,
              private bringozLoaderService: BringozLoaderService) {
  }

  getList() {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pdfFormTemplatesRequestsService.getList()
      .then((createdMetadata) => {
        deferred.resolve(createdMetadata);
      })
      .catch((error) => {
        this.pdfFormTemplatesAlerts.getListError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getOne(id: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pdfFormTemplatesRequestsService.getOne(id)
      .then((createdMetadata) => {
        deferred.resolve(createdMetadata);
      })
      .catch((error) => {
        this.pdfFormTemplatesAlerts.getOneError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createOne(pdfFormTemplate: PdfFormTemplateModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pdfFormTemplatesRequestsService.createOne(pdfFormTemplate)
      .then((createdMetadata) => {
        this.pdfFormTemplatesAlerts.createOneSuccess();
        deferred.resolve(createdMetadata);
      })
      .catch((error) => {
        this.pdfFormTemplatesAlerts.createOneError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  uploadOne(file: any) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pdfFormTemplatesRequestsService.uploadOne(file)
      .then((createdMetadata) => {
        deferred.resolve(createdMetadata);
      })
      .catch((error) => {
        this.pdfFormTemplatesAlerts.uploadOneError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateOne(id: string, pdfFormTemplate: PdfFormTemplateModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pdfFormTemplatesRequestsService.updateOne(id, pdfFormTemplate)
      .then((createdMetadata) => {
        this.pdfFormTemplatesAlerts.updateOneSuccess();
        deferred.resolve(createdMetadata);
      })
      .catch((error) => {
        this.pdfFormTemplatesAlerts.updateOneError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteOne(id: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.pdfFormTemplatesRequestsService.deleteOne(id)
      .then((createdMetadata) => {
        this.pdfFormTemplatesAlerts.deleteOneSuccess();
        deferred.resolve(createdMetadata);
      })
      .catch((error) => {
        this.pdfFormTemplatesAlerts.deleteOneError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.document-management')
  .service('pdfFormTemplatesService', PdfFormTemplatesService);
